import * as React from "react";
import type { SVGProps } from "react";
const SvgSettingLines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.667 11.668h1.666c.46 0 .834.373.834.833v3.334c0 .46-.374.833-.834.833h-1.666a.834.834 0 0 1-.834-.833V12.5c0-.46.374-.833.834-.833"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.5 14.167h-3.333M10.833 14.167H2.5"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.333 8.332H6.667a.834.834 0 0 1-.834-.833V4.165c0-.46.374-.833.834-.833h1.666c.46 0 .834.373.834.833V7.5c0 .46-.374.833-.834.833"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.5 5.835h3.333M9.167 5.835H17.5"
    />
  </svg>
);
export default SvgSettingLines;
